(function () {
  if (window.produktkarteBlockAktiv) return;
  window.produktkarteBlockAktiv = true;

  const parseJson = (el) => {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('Produktkarte: JSON konnte nicht gelesen werden.', e);
      return null;
    }
  };

  class ProduktkarteBlock {
    constructor(root) {
      this.root = root;
      this.abbau = [];
      this.data = parseJson(root.querySelector('[data-pkb-data]'));
      if (!this.data || !this.data.variant) return;

      this.strings = this.data.strings || {};
      this.variant = this.data.variant;
      this.variantIdInput = root.querySelector('.pkb__form input[name="id"]');
      this.sellingPlanInput = root.querySelector('[data-pkb-selling-plan]');
      this.modeInputs = Array.from(root.querySelectorAll('[data-pkb-mode]'));
      this.planCards = Array.from(root.querySelectorAll('[data-pkb-plan-card]'));
      this.intervalSelect = root.querySelector('[data-pkb-interval]');
      this.submit = root.querySelector('[data-pkb-submit]');
      this.submitLabel = root.querySelector('[data-pkb-submit-label]');
      this.mainPrice = root.querySelector('[data-pkb-mainprice]');
      this.qtyInput = root.querySelector('[data-pkb-qty-input]');
      this.qtyButtons = Array.from(root.querySelectorAll('[data-pkb-qty]'));
      this.qtyNote = root.querySelector('[data-pkb-qty-note]');
      this.stickyBar = root.querySelector('[data-pkb-stickybar]');
      this.buyRow = root.querySelector('[data-pkb-buyrow]');

      this.bind();
      this.bindVariantChange();
      this.initStickyBar();
      this.update();
    }

    bindVariantChange() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

      const abmelden = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!this.root.isConnected) return;

        const html = event && event.data && event.data.html;
        if (!html) return;

        const blockId = this.root.dataset.pkbRoot;
        const auswahl = blockId ? `[data-pkb-root="${blockId}"] [data-pkb-data]` : '[data-pkb-data]';
        const daten = parseJson(html.querySelector(auswahl));
        if (!daten || !daten.variant) return;

        this.strings = daten.strings || this.strings;
        this.variant = daten.variant;
        if (this.variantIdInput) this.variantIdInput.value = this.variant.id;
        this.update();
      });

      if (typeof abmelden === 'function') this.abbau.push(abmelden);
    }

    bind() {
      this.modeInputs.forEach((input) => {
        input.addEventListener('change', () => this.update());
      });

      this.planCards.forEach((card) => {
        card.addEventListener('click', (event) => {
          if (event.target.closest('select, a, [data-pkb-interval]')) return;
          const input = card.querySelector('[data-pkb-mode]');
          if (!input || input.checked || input.disabled) return;
          input.checked = true;
          this.update();
        });
      });

      if (this.intervalSelect) {
        this.intervalPerZeiger = false;

        this.intervalSelect.addEventListener('pointerdown', () => {
          this.intervalPerZeiger = true;
        });

        this.intervalSelect.addEventListener('blur', () => {
          this.intervalPerZeiger = false;
        });

        this.intervalSelect.addEventListener('change', () => {
          const subInput = this.modeInputs.find((i) => i.value === 'sub');
          if (subInput && !subInput.checked && !subInput.disabled) subInput.checked = true;
          if (this.intervalPerZeiger) this.intervalSelect.blur();
          this.update();
        });
      }

      this.qtyButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!this.qtyInput) return;
          const grenzen = this.qtyLimits();
          const richtung = button.dataset.pkbQty === 'plus' ? 1 : -1;
          const aktuell = parseInt(this.qtyInput.value, 10) || grenzen.min;
          this.qtyInput.value = this.clampQty(aktuell + richtung * grenzen.step, grenzen);
          this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      if (this.qtyInput) {
        this.qtyInput.addEventListener('change', () => {
          const grenzen = this.qtyLimits();
          this.qtyInput.value = this.clampQty(parseInt(this.qtyInput.value, 10), grenzen);
          this.updateQtyButtons();
        });
      }
    }

    qtyLimits() {
      const min = parseInt(this.qtyInput.min, 10) || 1;
      const step = parseInt(this.qtyInput.step, 10) || 1;
      const max = parseInt(this.qtyInput.max, 10) || 0;
      return { min, step, max: max >= min ? max : 0 };
    }

    clampQty(wert, grenzen) {
      const { min, step, max } = grenzen;
      let menge = Number.isFinite(wert) ? wert : min;
      if (menge < min) menge = min;
      menge = min + Math.round((menge - min) / step) * step;
      if (max > 0 && menge > max) {
        menge = min + Math.floor((max - min) / step) * step;
      }
      return menge < min ? min : menge;
    }

    istKaufbar(variant) {
      const min = variant.qtyMin || 1;
      const max = variant.qtyMax || 0;
      return Boolean(variant.available) && !(max > 0 && max < min);
    }

    applyQuantityRules(variant) {
      if (!this.qtyInput) return;
      const min = variant.qtyMin || 1;
      const step = variant.qtyStep || 1;
      const max = variant.qtyMax >= min ? variant.qtyMax : 0;

      this.qtyInput.min = min;
      this.qtyInput.step = step;
      if (max > 0) {
        this.qtyInput.max = max;
      } else {
        this.qtyInput.removeAttribute('max');
      }

      this.qtyInput.value = this.clampQty(parseInt(this.qtyInput.value, 10), { min, step, max });
    }

    updateQtyButtons() {
      if (!this.qtyInput) return;
      const { min, max } = this.qtyLimits();
      const aktuell = parseInt(this.qtyInput.value, 10) || min;
      this.qtyButtons.forEach((button) => {
        if (button.dataset.pkbQty === 'minus') button.disabled = aktuell <= min;
        if (button.dataset.pkbQty === 'plus') button.disabled = max > 0 && aktuell >= max;
      });
    }

    updateQtyNote(variant) {
      if (!this.qtyNote) return;
      let text = '';

      if (variant.qtyMin > 1) {
        text = (this.strings.qtyMinNote || '').replace('[anzahl]', variant.qtyMin);
      }

      this.qtyNote.textContent = text;
      this.qtyNote.hidden = text === '';
    }

    initStickyBar() {
      if (!this.stickyBar || !this.buyRow || typeof IntersectionObserver === 'undefined') return;

      const beobachter = new IntersectionObserver(
        (eintraege) => {
          eintraege.forEach((eintrag) => {
            const daruebergescrollt = eintrag.boundingClientRect.top < 0;
            this.stickyBar.hidden = eintrag.isIntersecting || !daruebergescrollt;
          });
        },
        { threshold: 0 }
      );

      beobachter.observe(this.buyRow);
      this.abbau.push(() => beobachter.disconnect());
    }

    updateMainPrice(kaufbar, preis, vergleich) {
      if (!this.mainPrice) return;
      const box = this.mainPrice.querySelector('.price');
      if (!box) return;

      box.classList.toggle('price--on-sale', Boolean(preis && vergleich));
      box.classList.toggle('price--sold-out', !kaufbar);

      this.mainPrice.querySelectorAll('.price__regular > .price-item--regular, .price__sale > .price-item--sale').forEach((node) => {
        node.textContent = preis;
      });
      this.mainPrice.querySelectorAll('.price__sale s.price-item--regular').forEach((node) => {
        node.textContent = vergleich;
      });
    }

    setText(selector, value) {
      this.root.querySelectorAll(selector).forEach((node) => {
        if (value === null || value === undefined || value === '') {
          node.hidden = true;
          node.textContent = '';
        } else {
          node.hidden = false;
          node.textContent = value;
        }
      });
    }

    syncPlanOptions(variant) {
      if (!this.intervalSelect) return null;

      const plans = variant.plans || {};
      let ersterVerfuegbar = null;

      Array.from(this.intervalSelect.options).forEach((option) => {
        const verfuegbar = Boolean(plans[option.value]);
        option.disabled = !verfuegbar;
        if (verfuegbar && ersterVerfuegbar === null) ersterVerfuegbar = option.value;
      });

      if (!plans[this.intervalSelect.value] && ersterVerfuegbar !== null) {
        this.intervalSelect.value = ersterVerfuegbar;
      }

      return ersterVerfuegbar;
    }

    update() {
      const variant = this.variant;
      this.syncPlanOptions(variant);

      const planId = this.intervalSelect ? this.intervalSelect.value : null;
      const allocation = planId && variant.plans ? variant.plans[planId] : null;

      const subInput = this.modeInputs.find((i) => i.value === 'sub');
      const onceInput = this.modeInputs.find((i) => i.value === 'once');

      if (subInput) {
        const subCard = subInput.closest('[data-pkb-plan-card]');
        const subUsable = Boolean(allocation);
        subInput.disabled = !subUsable;
        if (subCard) subCard.classList.toggle('is-unavailable', !subUsable);
        if (!subUsable && subInput.checked && onceInput) onceInput.checked = true;
      }

      const mode = this.modeInputs.find((i) => i.checked && !i.disabled);
      const isSub = Boolean(mode && mode.value === 'sub' && allocation);

      this.planCards.forEach((card) => {
        card.classList.toggle('is-active', card.dataset.pkbPlanCard === (isSub ? 'sub' : 'once'));
      });

      this.setText('[data-pkb-badge]', allocation ? allocation.badge : '');

      this.setText('[data-pkb-price="once"]', variant.price);
      this.setText('[data-pkb-compare="once"]', variant.compare);
      this.setText('[data-pkb-unit="once"]', variant.unit);

      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = isSub ? planId : '';
        this.sellingPlanInput.disabled = !isSub;
      }

      this.applyQuantityRules(variant);
      this.updateQtyNote(variant);
      this.updateQtyButtons();

      const buyable = this.istKaufbar(variant);
      const preis = isSub && allocation ? allocation.price : variant.price;
      const vergleich = isSub && allocation ? allocation.compare : variant.compare;

      this.updateMainPrice(buyable, preis, vergleich);

      let buttonText;
      if (!buyable) {
        buttonText = this.strings.soldOut || '';
      } else if (isSub) {
        buttonText = this.strings.subscribeLabel || '';
      } else {
        buttonText = this.strings.addLabel || '';
      }

      if (this.submit && this.submitLabel) {
        this.submit.disabled = !buyable;
        this.submit.setAttribute('aria-disabled', String(!buyable));
        this.submitLabel.textContent = buttonText;
      }

      if (this.stickyBar) {
        const barPreis = this.stickyBar.querySelector('[data-pkb-stickybar-price]');
        const barLabel = this.stickyBar.querySelector('[data-pkb-stickybar-label]');
        const barButton = this.stickyBar.querySelector('button');
        if (barPreis) barPreis.textContent = preis;
        if (barLabel) barLabel.textContent = buttonText;
        if (barButton) barButton.disabled = !buyable;
      }
    }

    destroy() {
      this.abbau.forEach((aufraeumen) => aufraeumen());
      this.abbau = [];
    }
  }

  const initTextToggle = (root, name, grenzeAus) => {
    const body = root.querySelector(`[data-pkb-${name}-body]`);
    const toggle = root.querySelector(`[data-pkb-${name}-toggle]`);
    if (!body || !toggle) return null;

    const labelMehr = toggle.dataset.mehr || 'Weiterlesen';
    const labelWeniger = toggle.dataset.weniger || 'Weniger anzeigen';
    let offen = false;
    let kuerzbar = false;

    const zeichne = () => {
      body.classList.toggle('is-collapsed', kuerzbar && !offen);
      toggle.hidden = !kuerzbar;
      toggle.textContent = offen ? labelWeniger : labelMehr;
      toggle.setAttribute('aria-expanded', offen ? 'true' : 'false');
    };

    const messen = () => {
      body.classList.remove('is-collapsed');

      requestAnimationFrame(() => {
        const grenze = grenzeAus(getComputedStyle(body));
        kuerzbar = grenze > 0 && body.scrollHeight > grenze + 5;
        if (!kuerzbar) offen = false;
        zeichne();
      });
    };

    toggle.addEventListener('click', () => {
      offen = !offen;
      zeichne();
    });

    messen();
    window.addEventListener('resize', messen, { passive: true });
    window.addEventListener('load', messen, { once: true });

    return () => {
      window.removeEventListener('resize', messen);
      window.removeEventListener('load', messen);
    };
  };

  const init = (scope) => {
    (scope || document).querySelectorAll('[data-pkb-root]').forEach((root) => {
      if (root.dataset.pkbReady === 'true') return;
      root.dataset.pkbReady = 'true';

      const karte = new ProduktkarteBlock(root);
      const textAbbau = initTextToggle(root, 'info', (stil) => parseInt(stil.getPropertyValue('--pkb-info-max'), 10) || 240);
      if (typeof textAbbau === 'function') karte.abbau.push(textAbbau);
      root.pkbInstanz = karte;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-pkb-root]').forEach((root) => {
      if (root.pkbInstanz) root.pkbInstanz.destroy();
      root.pkbInstanz = null;
    });
  });

  document.addEventListener('shopify:block:select', (event) => {
    const akkordeon = event.target.closest('.pkb__acc');
    if (akkordeon) akkordeon.open = true;
  });
})();
